var map = {
	"./1.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/1.ogg",
	"./10.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/10.ogg",
	"./12.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/12.ogg",
	"./13.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/13.ogg",
	"./14.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/14.ogg",
	"./17-old.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/17-old.ogg",
	"./17.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/17.ogg",
	"./18.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/18.ogg",
	"./2.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/2.ogg",
	"./3.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/3.ogg",
	"./4.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/4.ogg",
	"./5.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/5.ogg",
	"./6.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/6.ogg",
	"./7.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/7.ogg",
	"./8.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/8.ogg",
	"./a1.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/a1.ogg",
	"./a11.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/a11.ogg",
	"./a12.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/a12.ogg",
	"./a2.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/a2.ogg",
	"./a3.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/a3.ogg",
	"./a4.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/a4.ogg",
	"./a5.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/a5.ogg",
	"./a6.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/a6.ogg",
	"./a8.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/a8.ogg",
	"./aaha.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/aaha.ogg",
	"./aaha_old.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/aaha_old.ogg",
	"./aba_ta_ma_pani_school_jane.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/aba_ta_ma_pani_school_jane.ogg",
	"./b1.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/b1.ogg",
	"./b2.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/b2.ogg",
	"./b3.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/b3.ogg",
	"./b4.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/b4.ogg",
	"./blank.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/blank.ogg",
	"./blank0.1.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/blank0.1.ogg",
	"./blank6.5.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/blank6.5.ogg",
	"./boy-laugh.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/boy-laugh.ogg",
	"./bubble-pop.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/bubble-pop.ogg",
	"./desktop.ini": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/desktop.ini",
	"./dog_bark.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/dog_bark.ogg",
	"./g1.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/g1.ogg",
	"./g2.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/g2.ogg",
	"./kasto_ramailo.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/kasto_ramailo.ogg",
	"./p6.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/p6.ogg",
	"./se_page11.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/se_page11.ogg",
	"./se_page2to4.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/se_page2to4.ogg",
	"./soothing-music-fade.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/soothing-music-fade.ogg",
	"./soothing-music.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/soothing-music.ogg",
	"./ting.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/ting.ogg",
	"./title.ogg": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/title.ogg",
	"./wand_ping_001_12529.mp3": "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios/wand_ping_001_12529.mp3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/MaKinaSchoolJaneRa/audios sync recursive ^\\.\\/.*$";